import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from './apiClient';
import {
  GetInvestorPreferencesResponse,
  CreateInvestorPreferencesRequest,
  CreateInvestorPreferencesResponse,
  UpdateInvestorPreferencesRequest,
  UpdateInvestorPreferencesResponse,
  InvestorPreferencesDTO,
} from '@inversor-hub/types';
import { LIST_OPPORTUNITIES_KEY } from '@/lib/api/opportunities.ts';

export const INVESTOR_PREFERENCES_KEY = 'investor-preferences';

export function useGetInvestorPreferences(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: [INVESTOR_PREFERENCES_KEY],
    queryFn: async () => {
      const { data } =
        await apiClient.get<GetInvestorPreferencesResponse>(`/investors/preferences`);
      return data.data as InvestorPreferencesDTO | undefined;
    },
    enabled: options?.enabled,
  });
}

export function useCreateInvestorPreferences() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: CreateInvestorPreferencesRequest) => {
      const { data } = await apiClient.post<CreateInvestorPreferencesResponse>(
        `/investors/preferences`,
        input
      );
      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [INVESTOR_PREFERENCES_KEY] });
      queryClient.invalidateQueries({ queryKey: [LIST_OPPORTUNITIES_KEY] });
    },
  });
}

export function useUpdateInvestorPreferences() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input: UpdateInvestorPreferencesRequest) => {
      const { data } = await apiClient.put<UpdateInvestorPreferencesResponse>(
        `/investors/preferences`,
        input
      );
      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [INVESTOR_PREFERENCES_KEY] });
      queryClient.invalidateQueries({ queryKey: [LIST_OPPORTUNITIES_KEY] });
    },
  });
}
